// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_content__1ACVq {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 9999;
  padding: 0 20px 0 20px;
  overflow-y: auto;
  overflow-x: hidden;
}

.style_close__BUeKo {
  position: absolute;
  z-index: 9999;
  font-size: 20px;
  top: 20px;
  right: 17px;
  color: rgb(135, 135, 135);
}

.style_content__prize__3XLIb {
  position: relative;
  margin-top: 20px;
  height: 410px;
  display: flex;
  justify-content: center;
  width: 100%;
}
@media screen and (min-height: 600px) {
  .style_content__prize__3XLIb {
    margin-top: 60px;
  }
}

.style_content__logo__d7C7u {
  width: 300px;
  height: 120px;
  position: absolute;
  z-index: 3;
  top: 0;
}
.style_content__logo__d7C7u img {
  width: 100%;
  height: 100%;
}

.style_sunshine__TV6wj {
  width: 100%;
  height: 440px;
  width: 360px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}
.style_sunshine__TV6wj img {
  width: 100%;
  height: 100%;
}

.style_trophy__1B-TL {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 240px;
  height: 240px;
  z-index: 3;
}
.style_trophy__1B-TL img {
  width: 100%;
  height: 100%;
}

.style_ribbon__wrapper__SK96S {
  position: absolute;
  bottom: 50px;
  z-index: 4;
  left: 50%;
  transform: translate(0%, 0%);
}

.style_cloud__left__AFz7e {
  position: absolute;
  top: 78%;
  left: 14%;
  transform: translate(-50%, -50%);
  width: 276px;
  height: 146px;
  z-index: 2;
}
.style_cloud__left__AFz7e img {
  width: 100%;
  height: 100%;
}

.style_cloud__right__bdLP9 {
  position: absolute;
  top: 78%;
  left: 95%;
  transform: translate(-50%, -50%);
  width: 276px;
  height: 146px;
  z-index: 2;
}
.style_cloud__right__bdLP9 img {
  width: 100%;
  height: 100%;
}

.style_socials__jcmim {
  display: flex;
  width: 90%;
  justify-content: center;
  gap: 4px;
  position: absolute;
  bottom: 10px;
  flex-direction: column;
}
.style_socials__item__IXUCv {
  display: flex;
}
@media screen and (max-height: 600px) {
  .style_socials__jcmim {
    position: relative;
  }
}
@media screen and (min-height: 600px) {
  .style_socials__jcmim {
    bottom: 30px;
  }
}

.style_content__reward__U3P7Q {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 30px 0 12px 0;
}
@media screen and (min-height: 600px) {
  .style_content__reward__U3P7Q {
    padding: 50px 0 12px 0;
  }
}
.style_content__reward__title__tB8ST {
  color: rgb(117, 83, 240);
  font-size: 1.4rem;
  font-weight: 500;
  margin-bottom: 4px;
}
.style_content__reward__body__3jFCz {
  display: flex;
  gap: 4px;
  color: rgb(117, 83, 240);
}
.style_content__reward__body__3jFCz img {
  width: 20px;
  height: 20px;
}
.style_content__reward__body__3jFCz p {
  color: rgb(117, 83, 240);
  font-size: 20px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/components/achievement-reward/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,oCCHM;EDIN,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,yBCrBU;ADoBZ;;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AADF;AAEE;EAPF;IAQI,gBAAA;EACF;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;AAEJ;;AAEA;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,YAAA;EAEA,UAAA;EACA,SAAA;EACA,4BAAA;AAAF;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AAAF;AACE;EACE,WAAA;EACA,YAAA;AACJ;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AAAF;AACE;EACE,WAAA;EACA,YAAA;AACJ;;AAGA;EACE,aAAA;EACA,UAAA;EACA,uBAAA;EAEA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;AADF;AAEE;EACE,aAAA;AAAJ;AAGE;EAbF;IAcI,kBAAA;EAAF;AACF;AAEE;EAjBF;IAkBI,YAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AACF;AAAE;EANF;IAOI,sBAAA;EAGF;AACF;AAFE;EACE,wBCrJG;EDsJH,iBAAA;EACA,gBAAA;EACA,kBAAA;AAIJ;AAFE;EACE,aAAA;EACA,QAAA;EACA,wBC7JG;ADiKP;AAHI;EACE,WAAA;EACA,YAAA;AAKN;AAHI;EACE,wBCnKC;EDoKD,eAAA;EACA,gBAAA;AAKN","sourcesContent":["@import 'public/assets/colors';\n\n.content {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background-color: $white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 9999;\n  padding: 0 20px 0 20px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.close {\n  position: absolute;\n  z-index: 9999;\n  font-size: 20px;\n  top: 20px;\n  right: 17px;\n  color: $dark-grey;\n}\n\n.content__prize {\n  position: relative;\n  margin-top: 20px;\n  height: 410px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  @media screen and (min-height: 600px) {\n    margin-top: 60px;\n  }\n}\n\n.content__logo {\n  width: 300px;\n  height: 120px;\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.sunshine {\n  width: 100%;\n  height: 440px;\n  width: 360px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.trophy {\n  position: absolute;\n  top: 60%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 240px;\n  height: 240px;\n  z-index: 3;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.ribbon__wrapper {\n  position: absolute;\n  bottom: 50px;\n  // bottom: 0;\n  z-index: 4;\n  left: 50%;\n  transform: translate(-0%, -0%);\n}\n\n.cloud__left {\n  position: absolute;\n  top: 78%;\n  left: 14%;\n  transform: translate(-50%, -50%);\n  width: 276px;\n  height: 146px;\n  z-index: 2;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.cloud__right {\n  position: absolute;\n  top: 78%;\n  left: 95%;\n  transform: translate(-50%, -50%);\n  width: 276px;\n  height: 146px;\n  z-index: 2;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.socials {\n  display: flex;\n  width: 90%;\n  justify-content: center;\n\n  gap: 4px;\n  position: absolute;\n  bottom: 10px;\n  flex-direction: column;\n  &__item {\n    display: flex;\n  }\n\n  @media screen and (max-height: 600px) {\n    position: relative;\n  }\n\n  @media screen and (min-height: 600px) {\n    bottom: 30px;\n  }\n}\n\n.content__reward {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 30px 0 12px 0;\n  @media screen and (min-height: 600px) {\n    padding: 50px 0 12px 0;\n  }\n  &__title {\n    color: $main;\n    font-size: 1.4rem;\n    font-weight: 500;\n    margin-bottom: 4px;\n  }\n  &__body {\n    display: flex;\n    gap: 4px;\n    color: $main;\n    img {\n      width: 20px;\n      height: 20px;\n    }\n    p {\n      color: $main;\n      font-size: 20px;\n      font-weight: 700;\n    }\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `style_content__1ACVq`,
	"close": `style_close__BUeKo`,
	"content__prize": `style_content__prize__3XLIb`,
	"content__logo": `style_content__logo__d7C7u`,
	"sunshine": `style_sunshine__TV6wj`,
	"trophy": `style_trophy__1B-TL`,
	"ribbon__wrapper": `style_ribbon__wrapper__SK96S`,
	"cloud__left": `style_cloud__left__AFz7e`,
	"cloud__right": `style_cloud__right__bdLP9`,
	"socials": `style_socials__jcmim`,
	"socials__item": `style_socials__item__IXUCv`,
	"content__reward": `style_content__reward__U3P7Q`,
	"content__reward__title": `style_content__reward__title__tB8ST`,
	"content__reward__body": `style_content__reward__body__3jFCz`
};
export default ___CSS_LOADER_EXPORT___;
